module.exports = __webpack_public_path__ + "bg.png?ecb06bf1481a2c6d41ae52b64c96c8cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = 49
// module chunks = 0